import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

// Antd Components
import { Modal, Select, Row, Col, InputNumber, message, Input } from "antd";
import instance from "../../../store/actions/instance";
import { setProductsSuppliers, setProductUnits } from "../../../store/actions";
const { Option } = Select;

export const getDefaultUnit = (units, baseUnit, type) => {
  let unit = units.find((u) => u[type]);
  return unit || baseUnit;
};
class AddPurchaseProductModal extends Component {
  state = {
    selectedProduct: null,
    quantity: 1,
    cost: this.props.productSupplier?.price || 0,
    supplierCode: this.props.productSupplier?.code,
  };
  saveButtonDisabled = () => {
    const { selectedProduct, quantity } = this.state;

    return !selectedProduct || quantity <= 0;
  };

  fetchProductUnits = async (productID) => {
    const { t } = this.props;
    try {
      this.setState({ loading: true });
      const res = await instance.get(`/get_product_units/${productID}`);
      this.props.setProductUnits({
        productID: productID,
        units: res.data,
      });
      return res.data;
    } catch (err) {
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(t("SomethingWentWrong"));
    }
    this.setState({ loading: false });
  };
  fetchProductsSuppliers = async (productsIds) => {
    const { t } = this.props;
    try {
      this.setState({ loading: true });
      const res = await instance.post(`/get_products_suppliers/`, {
        productsIds: [productsIds],
      });
      this.props.setProductsSuppliers(res.data);
      this.setState({ loading: false });
      return res.data;
    } catch (err) {
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(t("SomethingWentWrong"));
    }
    this.setState({ loading: false });
  };

  render() {
    const { visible, t, config, allProducts, supplierId, currentProductsIds } =
      this.props;
    const { quantity, cost, supplierCode } = this.state;
    const productsFromSupplier = [];

    allProducts.forEach((p) => {
      if (
        p.type_of_product === "stocked" &&
        !p.is_deleted &&
        !currentProductsIds.includes(p.id)
      ) {
        productsFromSupplier.push(
          <Option key={p.id} value={p.id}>
            <span style={{ whiteSpace: "break-spaces" }}>
              {(config.language === "arabic" && p.ar_name) || p.name}
            </span>
          </Option>
        );
      }
    });

    return (
      <Modal
        style={{ top: 20 }}
        destroyOnClose={true}
        title={
          <div
            className="ant-modal-title"
            style={{
              textAlign: config.direction == "rtl" ? "right" : "left",
            }}
          >
            {t("Select a product")}
          </div>
        }
        visible={visible}
        onCancel={() => this.props.onClose()}
        onOk={async () => {
          const { selectedProduct } = this.state;
          const { units, supplierId } = this.props;
          let productUnits = selectedProduct?.units?.filter(
            (u) => !u.is_deleted
          );
          let productSuppliers = selectedProduct?.suppliers?.filter(
            (s) => !s.is_deleted
          );

          if (!selectedProduct?.units) {
            productUnits = await this.fetchProductUnits(selectedProduct?.id);
          }
          if (!selectedProduct?.suppliers) {
            productSuppliers = await this.fetchProductsSuppliers(
              selectedProduct?.id
            );
          }

          const productSupplier = productSuppliers.find(
            (s) => s.supplier_id === supplierId
          );

          let baseUnit = units.find((u) => u.id === selectedProduct.unit);
          baseUnit = {
            ...baseUnit,
            unit__name: baseUnit?.name,
            unit__ar_name: baseUnit?.ar_name,
            conversion_factor: 1,
            unit_id: baseUnit?.id || null,
          };
          this.props.onClose({
            name: selectedProduct.name,
            arName: selectedProduct.ar_name,
            sku: selectedProduct.sku,
            id: selectedProduct.id,
            key: selectedProduct.id,
            suppliersCost: cost || productSupplier?.price,
            quantity: quantity,
            baseUnit: baseUnit,
            unit: getDefaultUnit(
              productUnits || [],
              baseUnit,
              "default_for_purchase"
            ),
            units: productUnits || [],
            supplierCode: supplierCode || productSupplier?.code,
          });
        }}
        okButtonProps={{
          disabled: this.saveButtonDisabled(),
        }}
        okText={t("Next")}
        cancelText={t("Close")}
        bodyStyle={{
          paddingTop: 0,
          width: "auto",
          padding: "0px 18px",
          textAlign: config.direction == "ltr" ? "left" : "right",
        }}
      >
        <div className="px-2 mb-3">
          <Row className="my-2">
            <Col span={12}>
              <p style={{ marginTop: 5 }}>{t("Product")}</p>
            </Col>
            <Col span={12}>
              <Select
                placeholder={t("Select a product")}
                dropdownClassName={config.language === "arabic" && "text-right"}
                className="w-100"
                showSearch
                optionFilterProp="children"
                onSelect={(newSelectedProduct) => {
                  const newProduct = this.props.allProducts.find(
                    (p) => p.id === newSelectedProduct
                  );
                  this.setState({
                    selectedProduct: newProduct,
                    cost: newProduct.suppliers_price || 0,
                  });
                }}
                filterOption={(input, option) =>
                  option.children.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {productsFromSupplier}
              </Select>
            </Col>
          </Row>
          <Row className="my-2">
            <Col span={12}>
              <p style={{ marginTop: 5 }}>{t("Quantity")}</p>
            </Col>
            <Col span={12}>
              <InputNumber
                style={{ width: 80 }}
                value={quantity}
                onChange={(e) => {
                  if (e >= 1) this.setState({ quantity: parseInt(e) });
                }}
                min={1}
              />
            </Col>
          </Row>
          <Row className="my-2">
            <Col span={12}>
              <p style={{ marginTop: 5 }}>{t("Cost")}</p>
            </Col>
            <Col span={12}>
              <InputNumber
                style={{ width: 80 }}
                value={cost}
                onChange={(e) => {
                  if (e >= 0) this.setState({ cost: e });
                }}
                min={0}
              />
            </Col>
          </Row>
          <Row className="my-2">
            <Col span={12}>
              <p style={{ marginTop: 5 }}>{t("Vendor Code")}</p>
            </Col>
            <Col span={12}>
              <Input
                style={{ width: "100%" }}
                value={supplierCode}
                onChange={(e) => {
                  this.setState({ supplierCode: e.target.value });
                }}
                min={0}
              />
            </Col>
          </Row>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    config: state.config,
    settings: state.auth.settings,
    permissions: state.auth.permissions,
    allProducts: state.products.allProducts,
    units: state.products.units,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setProductUnits: (payload) => dispatch(setProductUnits(payload)),
    setProductsSuppliers: (payload) => dispatch(setProductsSuppliers(payload)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(AddPurchaseProductModal));
